import { Slider } from "@mantine/core";
import { ReactElement, useEffect, useState } from "react";
import { SLIDER_MARKS_DEFAULT, SLIDER_THUMB_SIZE } from "./constants";
import DisabledContainer from "@common/components/layout/DisabledContainer";
import { IStorageSliderProps } from "./types";
import { StorageSliderThumb } from "./StorageSlider.components";
import { getLabel, getMark, getMarkRealValue, getMarkValue } from "./utils";

export default function StorageSlider({
  disabled,
  marks = SLIDER_MARKS_DEFAULT,
  price,
  isYearly,
  defaultValue,
  value,
  onChange,
  onChangeEnd,
}: IStorageSliderProps): ReactElement {
  const billingFrequencyText = isYearly ? "year" : "month";

  const formattedDefaultValue =
    defaultValue && getMarkValue(defaultValue, marks);
  const formattedValue = value && getMarkValue(value, marks);

  // FIX
  // Mantine's Slider component is not updating
  // the onChange and onChangeEnd methods
  const [storageAmount, setStorageAmount] = useState(formattedDefaultValue);

  // onChange
  useEffect(() => {
    if (
      onChange &&
      storageAmount !== undefined &&
      formattedValue !== storageAmount
    ) {
      onChange(getMarkRealValue(storageAmount, marks));
    }
  }, [onChange, onChangeEnd, storageAmount, formattedValue, marks]);

  // onChangeEnd
  const [isChangeEnd, setIsChangeEnd] = useState(false);
  useEffect(() => {
    if (
      isChangeEnd &&
      onChangeEnd &&
      storageAmount !== undefined &&
      formattedValue !== storageAmount
    ) {
      onChangeEnd(getMarkRealValue(storageAmount, marks));
      setIsChangeEnd(false);
    }
  }, [
    onChange,
    onChangeEnd,
    storageAmount,
    formattedValue,
    isChangeEnd,
    marks,
  ]);
  //

  return (
    <DisabledContainer disabled={disabled}>
      <Slider
        data-testid="StorageSlider"
        disabled={disabled}
        defaultValue={storageAmount}
        value={formattedValue}
        label={(value) =>
          getLabel(getMark(value, marks), price, billingFrequencyText)
        }
        min={0}
        marks={marks}
        max={marks.length - 1}
        step={1}
        thumbChildren={<StorageSliderThumb />}
        thumbSize={SLIDER_THUMB_SIZE}
        onChange={setStorageAmount}
        onChangeEnd={(val) => {
          setStorageAmount(val);
          setIsChangeEnd(true);
        }}
      />
    </DisabledContainer>
  );
}
